import React from "react"
import { api, firestore } from "../../core"
import { useSelectionParticipants, useSelectionParticipantsByUserId } from "popopo-lib-front/firestore-access"
import { getParticipantImageUrl } from "popopo-lib-front/live-comment-utils"
import { User } from "firebase/auth"
import { LiveId, SelectionId, SelectionParticipantId, SelectionParticipantNominateDocument, SpaceKey, UserId } from "popopo-msg"
import { Button } from "react-bootstrap"

export const SelectionParticipantListForSpaceUser = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId; selectionId: SelectionId }) => {
  const participants = useSelectionParticipants(firestore, props.spaceKey, props.liveId, props.selectionId)
  if (participants === "loading") {
    return <li><i className="fas fa-spin fa-spinner" /></li>
  }
  return <SelectionParticipantList { ...props} participants={participants.sort((a, b) => a.created_at - b.created_at) } />
}

export const SelectionParticipantListForGuest = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId; selectionId: SelectionId, userId: UserId }) => {
  const participants = useSelectionParticipantsByUserId(firestore, props.spaceKey, props.liveId, props.selectionId, props.userId)
  if (participants === "loading") {
    return <li><i className="fas fa-spin fa-spinner" /></li>
  }
  return <p>
    <p>自分の応募のみ表示中</p>
    <SelectionParticipantList {...props} participants={participants} />
  </p>
}

const SelectionParticipantList = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId; selectionId: SelectionId, participants: SelectionParticipantNominateDocument[] }) => {

  const onDelete = async (id: SelectionParticipantId) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.DELETE("/api/v2/spaces/{space_key}/lives/{live_id}/selections/{selection_id}/participants/{participant_id}", {
        params: { path: { space_key: props.spaceKey, live_id: props.liveId, selection_id: props.selectionId, participant_id: id } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <ul className="list-group w-100">
        {props.participants.length === 0 ? (
          <li>応募は1つも存在しません。</li>
        ) : (
          props.participants.map((participant) => (
            <li key={participant.id} className="list-group-item">
              {(() => { const url = getParticipantImageUrl(participant); return url ? <img alt="応募画像" src={url} width={200} /> : null })()}
              ID: {participant.id} (UID: {participant.user.id}, name: {participant.user.name})<br />
              {participant.description}
              <Button variant="danger" onClick={() => onDelete(participant.id)}>
                Delete
              </Button>
            </li>
          ))
        )}
      </ul>
    </>
  )
}
